module.exports = __webpack_public_path__ + "static/img/img_cabinet.ea67a6f5.png";